import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { InteroperableDataService } from '../../services/interoperableDataService';

export const SelectCity = ({ selectedCity, onChange, stateCode, getData, disabled, maskLabel }) => {
  const { translate: t } = useDictionaryTranslation();
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectCity = (item) => {
    const city = cities.find((c) => c._id === item?.value);
    onChange(city);
  };

  const getCities = useCallback(
    async (search) => {
      setLoading(true);
      try {
        const params = { search, stateCode };
        const { cities: citiesList } = await getData(params);
        setCities(citiesList);
      } catch (error) {
        setCities([]);
      } finally {
        setLoading(false);
      }
    },
    [stateCode],
  );

  useEffect(() => {
    getCities();
  }, [getCities]);

  const getOptionData = useCallback((city) => {
    return {
      value: city._id,
      label: city.municipality_name,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t('cityPlaceholder')}
      isLoading={loading}
      onChange={selectCity}
      options={cities}
      value={selectedCity}
      onSearch={getCities}
      getOptionData={getOptionData}
      disabled={disabled}
      maskLabel={maskLabel}
    />
  );
};

SelectCity.propTypes = {
  selectedCity: PropTypes.shape({
    state_code: PropTypes.string,
    municipality_name: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  stateCode: PropTypes.string,
  getData: PropTypes.func,
  disabled: PropTypes.bool,
  maskLabel: PropTypes.func,
};

SelectCity.defaultProps = {
  getData: InteroperableDataService.getCities,
};
